export default __webpack_public_path__ + "static/media/Residentie-reinaart.5f6a58de.png";